import React from "react"
import { motion, AnimatePresence } from "framer-motion"
import FiltersContent from "./FiltersContent"

const MobileFiltersDrawer = ({
  open,
  onClose,
  pf,
  setPF,
  setPFCond,
  openSelectId,
  setOpenSelectId,
  onApply,
  onClear,
  OPT,
}) => {
  const handleApply = () => {
    onApply()
    onClose()
  }

  const handleClear = () => {
    onClear()
    onClose()
  }

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 z-[80] bg-black/40"
            onClick={onClose}
          />
          <motion.div
            initial={{ y: "-100%" }}
            animate={{ y: 0 }}
            exit={{ y: "-100%" }}
            transition={{ duration: 0.3, ease: [0.32, 0.72, 0, 1] }}
            className="fixed top-0 left-0 right-0 z-[90] bg-white shadow-2xl rounded-b-2xl"
            style={{
              maxHeight: "85vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100 flex-shrink-0">
              <span className="font-semibold text-sm text-gray-900">Фильтры</span>
              <button
                onClick={onClose}
                className="p-2 rounded-xl hover:bg-gray-100 text-gray-400 transition-colors"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="overflow-y-auto flex-1">
              <FiltersContent
                pf={pf}
                setPF={setPF}
                setPFCond={setPFCond}
                openSelectId={openSelectId}
                setOpenSelectId={setOpenSelectId}
                onApply={handleApply}
                onClear={handleClear}
                OPT={OPT}
              />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}

export default MobileFiltersDrawer
